import React from 'react';
import './App.css'
import LayerIcon from '@material-ui/icons/Layers'
import ServiceIcon from '@material-ui/icons/Ballot'
import FileIcon from '@material-ui/icons/FolderShared'
import { Admin, Resource } from 'react-admin';
import UserList from './components/UserList'
import UserCreate from './components/UserCreate'
import UserEdit from './components/UserEdit'
import ServiceList from './components/ServiceList'
import ServiceCreate from './components/ServiceCreate'
import ServiceEdit from './components/ServiceEdit'
import LayerList from './components/LayerList'
import LayerEdit from './components/LayerEdit'
import LayerCreate from './components/LayerCreate'
import FileList from './components/FileList'
import FileEdit from './components/FileEdit'
import UploadList from './components/UploadList'
import Upload from './components/Upload'
import UploadContainer from './components/UploadContainer'
import authProvider from './authProvider'
// import { restClient } from 'ra-data-feathers'
import feathersClient from './feathers'
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import { restClient, authClient } from 'ra-data-feathers';

const generateClassName = createGenerateClassName();
const jss = create({
  ...jssPreset(),
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: document.getElementById('jss-insertion-point'),
});

const options = {
  id: '_id',
  usePatch: true
}

const restClientOptions = {
  id: '_id', // In this example, the database uses '_id' rather than 'id'
  usePatch: true // Use PATCH instead of PUT for updates
};

const authClientOptions = {
  storageKey: 'accessToken', // The key in localStorage used to store the authentication token
  authenticate: { // Options included in calls to Feathers client.authenticate
    strategy: 'local', // The authentication strategy Feathers should use
  },
  permissionsKey: 'permissions', // The key in localStorage used to store permissions from decoded JWT
  permissionsField: 'roles', // The key in the decoded JWT containing the user's role
  passwordField: 'password', // The key used to provide the password to Feathers client.authenticate
  usernameField: 'email', // The key used to provide the username to Feathers client.authenticate
  redirectTo: '/login', // Redirect to this path if an AUTH_CHECK fails. Uses the react-admin default of '/login' if omitted.
}

const App = () => {
  return (
    <JssProvider jss={jss} generateClassName={generateClassName}>
    <Admin
      // authProvider={authProvider}
      // dataProvider={restClient(feathersClient, options)}
      dataProvider={restClient(feathersClient, restClientOptions)}
      authProvider={authClient(feathersClient, authClientOptions)}
      title='LOOKNorth users'
      >
      <Resource name='users' list={UserList} edit={UserEdit} create={UserCreate} />
      <Resource name='services' list={ServiceList} edit={ServiceEdit} create={ServiceCreate} icon={ServiceIcon} />
      <Resource name='layers' list={LayerList} edit={LayerEdit} create={LayerCreate} icon={LayerIcon} />
      <Resource name='upload' list={UploadContainer} icon={FileIcon} profile={{ user: 'user' }} />
      <Resource name='files' list={FileList} edit={FileEdit} icon={FileIcon} />

    </Admin>
  </JssProvider>
  )
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js